var _ellipse, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusRedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9,
    cy: 9,
    rx: 6,
    ry: 6,
    transform: "rotate(-90 9 9)",
    fill: "#D71249"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8.5,
    transform: "rotate(-90 9 9)",
    stroke: "#D71249"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusRedIcon);
export default __webpack_public_path__ + "static/media/status_red_icon.9481dbd124b19146f4ea81df9853c818.svg";
export { ForwardRef as ReactComponent };